module.exports = __webpack_public_path__ + "static/BungeeInline-Regular-3484bcabcc22d08a4519a9c651ceed66.woff2";